import React from 'react';
import OpsPage from '../domains/ops/components/OpsPage';

const AdminOpsPage: React.FC = () => {
  return <OpsPage />;
};

export default AdminOpsPage;

